var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-result',{attrs:{"status":"403","title":"403","sub-title":"抱歉，您无权访问此页面。"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":()=> _vm.$router.history.go(-1)}},[_vm._v(" 返回 ")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }